<template>
  <div class="topup-header">
    <div class="topup-header-login">
      <div class="languages">
        <button class="lang" :class="[locale, {active: $i18n.locale() === locale}]"
              v-for="locale in $i18n.locales()"
              :key="'i81n-' + locale"
              @click="setLang(locale)"
              v-text="getLangToDisplay(locale)"
              :disabled="$i18n.locale() === locale"
              :title="$i18n.locale() === locale ? '' : $t(`component.header.a11y.languages.${locale}`)">
        </button>
      </div>
      <div class="no-wrap" v-if="isUserLoading">{{ $t('component.header.loading') }}</div>
      <div v-if="!isUserLoading">
        <div v-if="isPhoneResolution">
          <a v-if="!isUserLogged" class="login-link" :href="loginUrl" rel="noreferrer">
            {{ $t('component.header.linkLogin') }}
          </a>
          <div v-if="isUserLogged">
            <button type="button" class="menu-icon" @click="toggleDrawer()" :title="$t('component.header.a11y.hamburgerButton')"></button>
            <el-drawer :visible.sync="drawer"
                       size="60%"
                       @opened="addEventListeners"
                       @close="removeEventListeners">
              <nav class="menu-mobile">
                <a href="" @click.prevent="goToMainPage" :title="$t('component.header.a11y.nav.linkTopup')">{{ $t('component.header.linkTopup') }}</a>
                <router-link to="/historia-doladowan" v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate" rel="noreferrer" :title="$t('component.header.a11y.nav.linkHistory')">{{ $t('component.header.linkHistory') }}</a>
                </router-link>
                <router-link to="/kontakty" v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate" rel="noreferrer" :title="$t('component.header.a11y.nav.linkContacts')">{{ $t('component.header.linkContacts') }}</a>
                </router-link>
                <router-link to="/moje-dane" v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate" :title="$t('component.header.a11y.nav.linkMyData')">{{ $t('component.header.linkMyData') }}</a>
                </router-link>
                <router-link to="/wylogowanie" v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate" rel="noreferrer" :title="$t('component.header.a11y.nav.linkLogout')">{{ $t('component.header.linkLogout') }}</a>
                </router-link>
              </nav>
            </el-drawer>
          </div>
        </div>
        <div v-if="!isPhoneResolution">
          <a v-if="!isUserLogged" class="login-link" :href="loginUrl" rel="noreferrer">
            {{ $t('component.header.linkLogin') }}
          </a>
          <nav v-if="isUserLogged">
            <a href="" @click.prevent="goToMainPage" :title="$t('component.header.a11y.nav.linkTopup')">{{ $t('component.header.linkTopup') }}</a>
            <router-link to="/historia-doladowan" v-slot="{ href, navigate }">
              <a :href="href" @click="navigate" :title="$t('component.header.a11y.nav.linkHistory')">{{ $t('component.header.linkHistory') }}</a>
            </router-link>
            <router-link to="/kontakty" v-slot="{ href, navigate }">
              <a :href="href" @click="navigate" :title="$t('component.header.a11y.nav.linkContacts')">{{ $t('component.header.linkContacts') }}</a>
            </router-link>
            <router-link to="/moje-dane" v-slot="{ href, navigate }">
              <a :href="href" @click="navigate" :title="$t('component.header.a11y.nav.linkMyData')">{{ $t('component.header.linkMyData') }}</a>
            </router-link>
            <a :href="logoutUrl" rel="noreferrer" :title="$t('component.header.a11y.nav.linkLogout')">{{ $t('component.header.linkLogout') }}</a>
          </nav>
        </div>
      </div>
    </div>
    <nav class="topup-header-main">
      <router-link to="/" v-slot="{ href, navigate }">
        <a class="logo" :href="href" @click="navigate" :title="$t('component.header.a11y.nav.main')" >
          <img src="../assets/images/Plus_small_logo.png" alt="Logo Plus"/>
        </a>
      </router-link>
      <div class="slogan">{{ $t('component.header.title') }}</div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import HeaderMixin from '@/common/mixins/Layout/Header.mixin'

export default {
  name: 'TopupHeader',
  mixins: [HeaderMixin],
  computed: {
    ...mapState({
      loginUrl: state => state.user.data.loginUrl,
      logoutUrl: state => state.user.data.logoutUrl
    }),
    ...mapGetters({
      isUserLogged: 'isUserLogged',
      isUserLoading: 'isUserLoading'
    })
  }
}
</script>

<style src="../assets/scss/header.scss" lang="scss"></style>
